import { FieldPath, FieldValues, RegisterOptions, useFormContext } from "react-hook-form";

import { FilterableSinglePickerFormField } from "src/components/Form/FilterableSinglePickerFormField";
import { useGetBlacklistSchemasQuery } from "src/graphql/anti-fraud/queries/blacklists/BlacklistSchemasQuery";
import { ClientSchemaBlacklist } from "src/types/clientSchema";

export type BlacklistFilterableSinglePickerFormFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = {
  id: string;
  label?: string;
  helperText?: string;
  placeholder?: string;
  rules?: Omit<
    RegisterOptions<TFieldValues, TName>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
  name: TName;
};

export function BlacklistFilterableSinglePickerFormField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  id,
  helperText,
  placeholder,
  label,
  rules,
}: BlacklistFilterableSinglePickerFormFieldProps<TFieldValues, TName>) {
  const { control, setError } = useFormContext<TFieldValues>();

  const { data: blacklists, loading } = useGetBlacklistSchemasQuery({
    onError: (error) => {
      setError(name, { message: error.message });
    },
  });

  return (
    <FilterableSinglePickerFormField<ClientSchemaBlacklist, TFieldValues, TName>
      id={id}
      name={name}
      control={control}
      label={label}
      getOptionLabel={(item) => item.name}
      getOptionValue={(item) => item.code}
      rules={rules}
      options={blacklists}
      loading={loading}
      helperText={helperText}
      placeholder={placeholder}
      fullOption={true}
    />
  );
}
